// The page that owns the sidebar toggle provides `is_sidebar_collapsed`.
// A sidebar rendered without that page (e.g. the mobile panel) is treated as expanded.
function is_sidebar_expanded() {
    return false;
}

export default {
    is_sidebar_collapsed: {
        from: "is_sidebar_collapsed",
        default: () => is_sidebar_expanded
    }
};
